<script>
export default {
    page() {
        const title = 'Recently Played'
        const description = 'Recently played DJ mixes on FRISKY.'
        const image = `${import.meta.env.VITE_CLIENT_URL}/frisky-social-share-image.png`
        const canonicalUrl = `https://frisky.fm${this.$route.path}`
        return {
            title,
            link: [{ rel: 'canonical', vmid: 'canonical', href: canonicalUrl }],
            meta: [
                { name: 'title', vmid: 'title', content: title },
                { name: 'description', vmid: 'description', content: description },

                { property: 'og:title', vmid: 'og:title', content: title },
                { property: 'og:description', vmid: 'og:description', content: description },
                { property: 'og:image', vmid: 'og:image', content: image },
                { property: 'og:type', vmid: 'og:type', content: 'website' },
                { property: 'og:url', vmid: 'og:url', content: canonicalUrl },
                { property: 'og:site_name', vmid: 'og:site_name', content: 'FRISKY' },

                { name: 'twitter:card', vmid: 'twitter:card', content: 'summary_large_image' },
                { name: 'twitter:title', vmid: 'twitter:title', content: title },
                { name: 'twitter:description', vmid: 'twitter:description', content: description },
                { name: 'twitter:image', vmid: 'twitter:image', content: image },
                { name: 'twitter:url', vmid: 'twitter:url', content: canonicalUrl },
            ],
        }
    },
}
</script>

<script setup>
import { computed, onMounted, ref, watch } from 'vue'
import { useStore } from '@composables/use-store'
import DataLayer from '@services/data-layer/index'
import MixGridBlock from '@components/mix-grid-block'

const store = useStore()

const mixes = ref([])

const recentlyPlayedMixes = computed(() => {
    const history = store.state.playback && store.state.playback.history

    return (
        history &&
        history.reduce((unique, id) => (unique.includes(id) ? unique : [...unique, id]), [])
    )
})

function getMixes() {
    const ids = recentlyPlayedMixes.value

    if (!ids || !ids.length) return

    Promise.all(ids.map(id => DataLayer.mixes.getById(id))).then(responses => {
        mixes.value = responses.map(response => response.body)
    })
}

watch(recentlyPlayedMixes, getMixes)

onMounted(getMixes)
</script>

<template>
    <BaseSection
        v-if="mixes && mixes.length"
        padded
    >
        <MixGridBlock :mixes="mixes" />
    </BaseSection>
</template>
